// extracted by mini-css-extract-plugin
export default {"container":"TutorDashboard_container__Fj7hs","aside":"TutorDashboard_aside__9sMEE","content":"TutorDashboard_content__M8Ije"};